export enum GenStockLevelStatus {
    outOfStock = 'outOfStock',
    inStock = 'inStock'
}
